// import React, { useState } from "react";
// import backgroundImage from "../../assets/HomePage.png";
// const ApplyPage = () => {
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     // Handle form submission logic here

//     // Simulate form submission success
//     setIsSubmitted(true);
//   };

//   return (
//     <div className="apply-page font-Questrial bg-gray-100 min-h-screen">
//       {/* Hero Section */}
//       <div
//         className="hero bg-blue-600 py-36 text-center"
//         style={{
//           backgroundImage: `url(${backgroundImage})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <h1 className="text-4xl font-extrabold mb-4">Apply Now</h1>
//         <p className="text-lg">Submit your application to join our team!</p>
//       </div>

//       {/* Main Content */}
//       <div className="container mx-auto py-12 px-6 max-w-3xl bg-white shadow-lg rounded-lg mt-8">
//         {isSubmitted ? (
//           <div className="text-center md:py-16">
//             <h1 className="text-3xl font-bold mb-8">Thank You!</h1>
//             <p className="text-lg text-gray-700">
//               Your application has been submitted successfully. We will get back
//               to you soon.
//             </p>
//           </div>
//         ) : (
//           <>
//             <h2 className="text-2xl font-semibold mb-6 text-center">
//               Application Form
//             </h2>

//             <form onSubmit={handleSubmit} className="space-y-6">
//               {/* Full Name */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>Full Name:</span>
//                   <input
//                     type="text"
//                     name="fullName"
//                     required
//                     className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
//                   />
//                 </label>
//               </div>

//               {/* Email */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>Email:</span>
//                   <input
//                     type="email"
//                     name="email"
//                     required
//                     className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
//                   />
//                 </label>
//               </div>

//               {/* Position Applying For */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>Which Position You're Applying For?</span>
//                   <select
//                     name="position"
//                     required
//                     className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
//                   >
//                     <option value="">Select Position</option>
//                     <option value="position1">Position 1</option>
//                     <option value="position2">Position 2</option>
//                     {/* Add more options as needed */}
//                   </select>
//                 </label>
//               </div>

//               {/* Years of Experience */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>
//                     How many years of Microsoft or other Cloud Sales experience
//                     do you have?
//                   </span>
//                   <select
//                     name="experience"
//                     required
//                     className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
//                   >
//                     <option value="">Select Experience</option>
//                     <option value="0-1">0-1 year</option>
//                     <option value="2-3">2-3 years</option>
//                     <option value="4-5">4-5 years</option>
//                     <option value="5+">5+ years</option>
//                   </select>
//                 </label>
//               </div>

//               {/* Highest Level of Education */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>
//                     What is the highest level of education you have completed?
//                   </span>
//                   <select
//                     name="education"
//                     required
//                     className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
//                   >
//                     <option value="">Select Education Level</option>
//                     <option value="highschool">High School</option>
//                     <option value="bachelor">Bachelor's Degree</option>
//                     <option value="master">Master's Degree</option>
//                     <option value="doctorate">Doctorate</option>
//                   </select>
//                 </label>
//               </div>

//               {/* Command Over English */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>Command over English?</span>
//                   <select
//                     name="english"
//                     required
//                     className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
//                   >
//                     <option value="">Select English Proficiency</option>
//                     <option value="beginner">Beginner</option>
//                     <option value="intermediate">Intermediate</option>
//                     <option value="advanced">Advanced</option>
//                   </select>
//                 </label>
//               </div>

//               {/* Caste Certificate */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>
//                     Do you have any caste certificate? If yes, please specify!
//                   </span>
//                   <input
//                     type="text"
//                     name="casteCertificate"
//                     className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
//                   />
//                 </label>
//               </div>

//               {/* Upload Resume */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>Upload Resume:</span>
//                   <input
//                     type="file"
//                     name="resume"
//                     required
//                     className="mt-1 block w-full text-gray-700 border border-gray-300 rounded-md shadow-sm focus:outline-none"
//                   />
//                 </label>
//               </div>

//               {/* Last In-Hand Monthly Salary */}
//               <div className="mb-6">
//                 <label className="block text-gray-700">
//                   <span>Last In-Hand Monthly Salary:</span>
//                   <input
//                     type="text"
//                     name="salary"
//                     required
//                     className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200"
//                   />
//                 </label>
//               </div>

//               {/* Submit Button */}
//               <button
//                 type="submit"
//                 className="w-full px-4 py-2 bg-blue-600 text-white font-semibold rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring focus:ring-blue-300"
//               >
//                 Submit Application
//               </button>
//             </form>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ApplyPage;

// import React, { useState } from "react";
// import emailjs from "emailjs-com";
// import { BlobServiceClient } from "@azure/storage-blob";
// import { Helmet } from "react-helmet";
// import { useParams, Link } from "react-router-dom";
// import jobData from "./jobs-data.json";
// const ApplyPage = () => {
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     position: "",
//     experience: "",
//     education: "",
//     english: "",
//     casteCertificate: "",
//     salary: "",
//     resume: null,
//   });
//   const { id } = useParams();
//   const job = jobData.find((job) => job.id.toString() === id);

//   if (!job) {
//     return <div className="text-center py-10">Job not found</div>;
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleFileChange = (e) => {
//     setFormData({ ...formData, resume: e.target.files[0] });
//   };

//   // const handleSubmit = async (event) => {
//   //   event.preventDefault();

//   //   const file = formData.resume;

//   //   if (!file) {
//   //     console.error("No file selected");
//   //     return;
//   //   }

//   //   try {
//   //     // Azure Blob Storage Setup using SAS Token (no backend)
//   //     const accountName = import.meta.env.VITE_AZURE_STORAGE_ACCOUNT_NAME;
//   //     const containerName = import.meta.env.VITE_AZURE_STORAGE_CONTAINER_NAME;
//   //     const sasToken = import.meta.env.VITE_AZURE_SAS_TOKEN;

//   //     const blobServiceClient = new BlobServiceClient(
//   //       `https://${accountName}.blob.core.windows.net/?${sasToken}`
//   //     );

//   //     const containerClient =
//   //       blobServiceClient.getContainerClient(containerName);

//   //     // Unique filename with timestamp to prevent overwrite
//   //     const blobName = `resumes/${Date.now()}-${file.name}`;
//   //     const blockBlobClient = containerClient.getBlockBlobClient(blobName);

//   //     // Upload file to Azure Blob
//   //     await blockBlobClient.uploadBrowserData(file, {
//   //       blobHTTPHeaders: {
//   //         blobContentType: file.type,
//   //       },
//   //     });

//   //     const fileURL = `https://${accountName}.blob.core.windows.net/${containerName}/${blobName}`;
//   //     console.log("✅ File uploaded:", fileURL);

//   //     // Send Email via EmailJS
//   //     await emailjs.send(
//   //       "service_uivadud",
//   //       "template_hiqop1f",
//   //       {
//   //         fullName: formData.fullName,
//   //         email: formData.email,
//   //         position: formData.position,
//   //         experience: formData.experience,
//   //         education: formData.education,
//   //         english: formData.english,
//   //         casteCertificate: formData.casteCertificate,
//   //         salary: formData.salary,
//   //         resume: fileURL,
//   //       },
//   //       "67Xx_1-q2lGCH0Hma"
//   //     );

//   //     setIsSubmitted(true);
//   //     console.log("✅ Email sent successfully");
//   //   } catch (error) {
//   //     console.error(
//   //       "❌ Error uploading file or sending email:",
//   //       error.message || error
//   //     );
//   //     setIsSubmitted(false);
//   //   }
//   // };
//   // const handleSubmit = async (event) => {
//   //   event.preventDefault();
//   //   setLoading(true); // Start loading

//   //   const file = formData.resume;

//   //   if (!file) {
//   //     console.error("No file selected");
//   //     setLoading(false); // Stop loading if file not selected
//   //     return;
//   //   }

//   //   try {
//   //     const accountName = import.meta.env.VITE_AZURE_STORAGE_ACCOUNT_NAME;
//   //     const containerName = import.meta.env.VITE_AZURE_STORAGE_CONTAINER_NAME;
//   //     const sasToken = import.meta.env.VITE_AZURE_SAS_TOKEN;

//   //     const blobServiceClient = new BlobServiceClient(
//   //       `https://${accountName}.blob.core.windows.net/?${sasToken}`
//   //     );

//   //     const containerClient =
//   //       blobServiceClient.getContainerClient(containerName);

//   //     const blobName = `resumes/${Date.now()}-${file.name}`;
//   //     const blockBlobClient = containerClient.getBlockBlobClient(blobName);

//   //     await blockBlobClient.uploadBrowserData(file, {
//   //       blobHTTPHeaders: {
//   //         blobContentType: file.type,
//   //       },
//   //     });

//   //     const fileURL = `https://${accountName}.blob.core.windows.net/${containerName}/${blobName}`;
//   //     console.log("✅ File uploaded:", fileURL);

//   //     await emailjs.send(
//   //       "service_uivadud",
//   //       "template_hiqop1f",
//   //       {
//   //         fullName: formData.fullName,
//   //         email: formData.email,
//   //         position: formData.position,
//   //         experience: formData.experience,
//   //         education: formData.education,
//   //         english: formData.english,
//   //         casteCertificate: formData.casteCertificate,
//   //         salary: formData.salary,
//   //         resume: fileURL,
//   //       },
//   //       "67Xx_1-q2lGCH0Hma"
//   //     );

//   //     setIsSubmitted(true);
//   //     console.log("✅ Email sent successfully");
//   //   } catch (error) {
//   //     console.error(
//   //       "❌ Error uploading file or sending email:",
//   //       error.message || error
//   //     );
//   //     setIsSubmitted(false);
//   //   } finally {
//   //     setLoading(false); // Always stop loading
//   //   }
//   // };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     // Check if already submitted (based on email or just any submission)
//     const submittedEmail = localStorage.getItem("submittedEmail");
//     if (submittedEmail === formData.email) {
//       alert("You have already submitted an application with this email.");
//       return;
//     }

//     setLoading(true); // Start loading

//     const file = formData.resume;

//     if (!file) {
//       console.error("No file selected");
//       setLoading(false);
//       return;
//     }

//     try {
//       const accountName = import.meta.env.VITE_AZURE_STORAGE_ACCOUNT_NAME;
//       const containerName = import.meta.env.VITE_AZURE_STORAGE_CONTAINER_NAME;
//       const sasToken = import.meta.env.VITE_AZURE_SAS_TOKEN;

//       const blobServiceClient = new BlobServiceClient(
//         `https://${accountName}.blob.core.windows.net/?${sasToken}`
//       );

//       const containerClient =
//         blobServiceClient.getContainerClient(containerName);

//       const blobName = `resumes/${Date.now()}-${file.name}`;
//       const blockBlobClient = containerClient.getBlockBlobClient(blobName);

//       await blockBlobClient.uploadBrowserData(file, {
//         blobHTTPHeaders: {
//           blobContentType: file.type,
//         },
//       });

//       const fileURL = `https://${accountName}.blob.core.windows.net/${containerName}/${blobName}`;
//       console.log("✅ File uploaded:", fileURL);

//       await emailjs.send(
//         "service_yr27zms",
//         "template_vpymdan",
//         {
//           fullName: formData.fullName,
//           email: formData.email,
//           position: formData.position,
//           experience: formData.experience,
//           education: formData.education,
//           english: formData.english,
//           casteCertificate: formData.casteCertificate,
//           salary: formData.salary,
//           resume: fileURL,
//         },
//         "4lbCjPNxpAcxPIevV"
//       );

//       // Mark this email as already submitted
//       localStorage.setItem("submittedEmail", formData.email);

//       setIsSubmitted(true);
//       console.log("✅ Email sent successfully");
//     } catch (error) {
//       console.error(
//         "❌ Error uploading file or sending email:",
//         error.message || error
//       );
//       setIsSubmitted(false);
//     } finally {
//       setLoading(false);
//     }
//   };
//   const isAlreadySubmitted =
//     localStorage.getItem("submittedEmail") === formData.email;

//   const truncateTitle = (title, maxLength = 60) => {
//     return title.length > maxLength
//       ? title.substring(0, title.lastIndexOf(" ", maxLength)) + "..."
//       : title;
//   };

//   const truncateText = (text, maxLength = 150) => {
//     return text.length > maxLength
//       ? text.substring(0, maxLength).trim() + "..."
//       : text;
//   };

//   return (
//     <>
//       <Helmet>
//         {/* Title */}
//         <title>{truncateTitle(`${job.title} | Careers at Navishaa`)}</title>

//         {/* Meta Description */}
//         <meta name="description" content={truncateText(job.description, 150)} />

//         {/* Canonical URL */}
//         <link rel="canonical" href={`https://www.navishaa.com/job/${job.id}`} />

//         {/* Open Graph (OG) tags */}
//         <meta property="og:locale" content="en_US" />
//         <meta property="og:type" content="website" />
//         <meta
//           property="og:title"
//           content={truncateTitle(`${job.title} | Careers at Navishaa`)}
//         />
//         <meta
//           property="og:description"
//           content={truncateText(job.description, 150)}
//         />
//         <meta
//           property="og:url"
//           content={truncateTitle(`${job.title} | Careers at Navishaa`)}
//         />
//         <meta property="og:site_name" content="Navishaa" />
//         <meta
//           property="og:image"
//           content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
//         />
//         <meta property="og:image:width" content="1200" />
//         <meta property="og:image:height" content="630" />

//         {/* Twitter tags */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:site" content="@Navishaa" />
//         <meta
//           name="twitter:title"
//           content={truncateTitle(`${job.title} | Careers at Navishaa`)}
//         />
//         <meta
//           name="twitter:description"
//           content={truncateText(job.description, 150)}
//         />
//         <meta
//           name="twitter:image"
//           content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
//         />
//         <meta name="twitter:label1" content="Written by" />
//         <meta name="twitter:data1" content="Navishaa" />
//         <meta name="twitter:label2" content="Est. reading time" />
//         <meta name="twitter:data2" content="3 minutes" />

//         {/* LinkedIn tags */}
//         <meta
//           property="og:url"
//           content="https://www.linkedin.com/company/navishaa/"
//         />
//         <meta
//           property="og:title"
//           content={truncateTitle(`${job.title} | Careers at Navishaa`)}
//         />
//         <meta
//           property="og:description"
//           content={truncateText(job.description, 150)}
//         />
//         <meta
//           property="og:image"
//           content="https://www.navishaa.com/images/api-integration-banner.png" // Update this image URL as needed
//         />

//         {/* Structured Data - Schema.org */}
//         <script type="application/ld+json">
//           {`
//                 {
//                   "@context": "https://schema.org",
//                   "@type": "Article",
//                   "headline": "https://www.navishaa.com/copilot-resources",
//                   "author": {
//                     "@type": "Person",
//                     "name": "Navishaa "
//                   },
//                   "datePublished": "2024-09-24",
//                   "dateModified": "2024-09-24",
//                   "image": {
//                     "@type": "ImageObject",
//                     "url": "https://www.navishaa.com/images/api-integration-banner.png",
//                     "width": 1200,
//                     "height": 630
//                   },
//                   "publisher": {
//                     "@type": "Organization",
//                     "name": "Navishaa",
//                     "logo": {
//                       "@type": "ImageObject",
//                       "url": "https://www.navishaa.com/images/logo.png",
//                       "width": 1854,
//                       "height": 503
//                     }
//                   },
//                   "mainEntityOfPage": "https://www.navishaa.com/job/${job.id}",
//                   "url": "https://www.navishaa.com/job/${job.id}",
//                   "description":{truncateText(job.description, 150)}
//                 }
//               `}
//         </script>
//       </Helmet>
//       <div className="apply-page font-Questrial bg-gradient-to-l from-pink-50 to-purple-50  min-h-screen">
//         <div
//           className="hero bg-blue-600 py-20 lg:py-36 text-center"
//           style={{
//             backgroundImage: `url("https://res.cloudinary.com/dbitupkaa/image/upload/f_auto,q_auto/v1737458572/HomePage_d3y2gy.png")`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//           }}
//         >
//           <h1 className="text-4xl md:text-5xl font-extrabold mb-4 text-black">
//             Apply Now
//           </h1>
//           <p className="text-lg md:text-xl">
//             Submit your application to join our team!
//           </p>
//         </div>
//         <div className="container mx-auto py-12 px-6 max-w-3xl bg-white shadow-lg rounded-lg mt-8 ">
//           {isSubmitted ? (
//             <div className="flex flex-col text-center items-center justify-center">
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 className="text-green-600 w-28 h-28"
//                 fill="none"
//                 viewBox="0 0 24 24"
//                 stroke="currentColor"
//                 strokeWidth="1"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                 />
//               </svg>
//               <h2 className="text-2xl font-bold mb-2">Thank You!</h2>
//               <p className="text-gray-700">
//                 Your application has been submitted successfully. We will get
//                 back to you soon
//               </p>
//             </div>
//           ) : (
//             <>
//               <h2 className="text-2xl font-semibold mb-6 text-center">
//                 Application Form
//               </h2>
//               <form onSubmit={handleSubmit} className="space-y-6">
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>Full Name:</span>
//                     <input
//                       type="text"
//                       name="fullName"
//                       placeholder="Full Name"
//                       required
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleChange}
//                     />
//                   </label>
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>Email:</span>
//                     <input
//                       type="email"
//                       name="email"
//                       placeholder="Email"
//                       required
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleChange}
//                     />
//                   </label>
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>Which Position You're Applying For?</span>
//                     <select
//                       name="position"
//                       required
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Position</option>
//                       {/* Add more options as needed */}
//                       <option value="Microsoft 365 Adoption Specialist">
//                         IT Technician
//                       </option>
//                       <option value="Microsoft 365 Adoption Specialist">
//                         IT Sales Executive
//                       </option>
//                       <option value="Microsoft 365 Adoption Specialist">
//                         Microsoft 365 Adoption Specialist
//                       </option>
//                       <option value="Microsoft 365 Technology Specialist">
//                         Microsoft 365 Technology Specialist
//                       </option>
//                       <option value="Microsoft Azure Cloud Specialist">
//                         Microsoft Azure Cloud Specialist
//                       </option>
//                       <option value="Senior Web Developer">
//                         Senior Web Developer
//                       </option>
//                       <option value="Microsoft Power App Developer">
//                         Microsoft Power App Developer
//                       </option>
//                     </select>
//                   </label>
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>Years of Experience:</span>
//                     <select
//                       name="experience"
//                       required
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Experience</option>
//                       <option value="0-1">0-1 year</option>
//                       <option value="2-3">2-3 years</option>
//                       <option value="4-5">4-5 years</option>
//                       <option value="5+">5+ years</option>
//                     </select>
//                   </label>
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>Highest Level of Education:</span>
//                     <select
//                       name="education"
//                       required
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleChange}
//                     >
//                       <option value="">Select Education</option>
//                       <option value="Bachelor's Degree">
//                         Bachelor's Degree
//                       </option>
//                       <option value="Master's Degree">Master's Degree</option>
//                       <option value="Doctorate">Doctorate</option>
//                     </select>
//                   </label>
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>English Proficiency:</span>
//                     <select
//                       name="english"
//                       required
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleChange}
//                     >
//                       <option value="">Select English Proficiency</option>
//                       <option value="Basic">Basic</option>
//                       <option value="Intermediate">Intermediate</option>
//                       <option value="Fluent">Fluent</option>
//                     </select>
//                   </label>
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>Do you have a caste certificate?</span>
//                     <input
//                       type="text"
//                       name="casteCertificate"
//                       placeholder="Caste Certificate Details (if applicable)"
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleChange}
//                     />
//                   </label>
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>Last In-hand Monthly Salary:</span>
//                     <input
//                       type="text"
//                       name="salary"
//                       placeholder="Your Last In-hand Monthly Salary"
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleChange}
//                     />
//                   </label>
//                 </div>
//                 <div className="mb-6">
//                   <label className="block text-gray-700 font-bold">
//                     <span>Upload Your Resume (PDF/DOC):</span>
//                     <input
//                       type="file"
//                       name="resume"
//                       accept=".pdf,.doc,.docx"
//                       required
//                       className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 font-medium"
//                       onChange={handleFileChange}
//                     />
//                   </label>
//                 </div>
//                 {/* <button
//                   type="submit"
//                   className=" bg-gradient-to-l from-[#9629E7] to-[#0860C7] text-white font-medium shadow-md hover:bg-opacity-90 hover:from-[#0860C7] hover:to-[#9629E7] py-2 px-6 rounded-lg transition duration-200 w-full"
//                 >
//                   Submit Application
//                 </button> */}
//                 {/* <button
//                   type="submit"
//                   disabled={loading}
//                   className={`w-full py-3 text-white font-semibold rounded-md transition duration-300 ${
//                     loading
//                       ? "bg-gray-400 cursor-not-allowed"
//                       : "bg-blue-600 hover:bg-blue-700"
//                   }`}
//                 >
//                   {loading ? (
//                     <span className="flex items-center justify-center">
//                       <svg
//                         className="animate-spin h-5 w-5 mr-2 text-white"
//                         xmlns="http://www.w3.org/2000/svg"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                       >
//                         <circle
//                           className="opacity-25"
//                           cx="12"
//                           cy="12"
//                           r="10"
//                           stroke="currentColor"
//                           strokeWidth="4"
//                         />
//                         <path
//                           className="opacity-75"
//                           fill="currentColor"
//                           d="M4 12a8 8 0 018-8v8H4z"
//                         />
//                       </svg>
//                       Applying...
//                     </span>
//                   ) : (
//                     "Submit Application"
//                   )}
//                 </button> */}
//                 <button
//                   type="submit"
//                   disabled={loading || isAlreadySubmitted}
//                   className={`w-full py-3 text-white font-semibold rounded-md transition duration-300 ${
//                     loading || isAlreadySubmitted
//                       ? "bg-gray-400 cursor-not-allowed"
//                       : "bg-blue-600 hover:bg-blue-700"
//                   }`}
//                 >
//                   {loading ? (
//                     <span className="flex items-center justify-center">
//                       {/* Spinner SVG */}
//                       Applying...
//                     </span>
//                   ) : isAlreadySubmitted ? (
//                     "Already Applied"
//                   ) : (
//                     "Submit Application"
//                   )}
//                 </button>
//               </form>
//             </>
//           )}
//         </div>
//       </div>
//       <div className="py-4 md:py-10 bg-gray-100"></div>
//     </>
//   );
// };

// export default ApplyPage;

//latest

// import React, { useState } from "react";
// import { Helmet } from "react-helmet";
// import { useParams } from "react-router-dom";
// import jobData from "./jobs-data.json";

// const ApplyPage = () => {
//   const { id } = useParams();
//   const job = jobData.find(
//     (job) => String(job.id).toLowerCase() === String(id).toLowerCase()
//   );

//   const [formData, setFormData] = useState({
//     fullName: "",
//     email: "",
//     phone: "",
//     position: job?.title || "",
//     experience: "",
//     education: "",
//     english: "",
//     salary: "",
//     relocate: "",
//     resume: null,
//   });

//   const [loading, setLoading] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [error, setError] = useState("");

//   if (!job) return <div className="text-center py-10">Job not found</div>;

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleFileChange = (e) => {
//     setFormData({ ...formData, resume: e.target.files[0] });
//   };

//   const fileToBase64 = (file) =>
//     new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = () => resolve(reader.result.split(",")[1]);
//       reader.onerror = (error) => reject(error);
//     });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     if (!formData.resume) {
//       alert("Please upload your resume.");
//       return;
//     }

//     setLoading(true);
//     try {
//       const resumeBase64 = await fileToBase64(formData.resume);
//       const resumeFilename = formData.resume.name;

//       const response = await fetch(
//         `${import.meta.env.VITE_API_BASE}/addApplication?code=${
//           import.meta.env.VITE_AZURE_FUNC_KEY
//         }`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             ...formData,
//             resumeBase64,
//             resumeFilename,
//             site: "Navishaa", // Added site identifier
//           }),
//         }
//       );

//       const data = await response.json();
//       if (!response.ok || !data.success) {
//         throw new Error(data.message || "Failed to submit application.");
//       }

//       setIsSubmitted(true);
//     } catch (err) {
//       console.error(err);
//       setError(err.message || "Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>
//           {job?.title
//             ? `${job.title} | Careers at GetMax`
//             : "Careers at GetMax"}
//         </title>
//         <meta
//           name="description"
//           content={
//             job?.description
//               ? job.description.substring(0, 150) + "..."
//               : "Explore exciting career opportunities at GetMax."
//           }
//         />
//       </Helmet>

//       <div className="apply-page font-Questrial bg-gray-50 min-h-screen">
//         {/* Hero Section */}
//         <div
//           className="hero relative py-16 lg:py-24 text-center text-white"
//           style={{
//             backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("https://res.cloudinary.com/dbitupkaa/image/upload/f_auto,q_auto/v1737458572/HomePage_d3y2gy.png")`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//           }}
//         >
//           <h1 className="text-3xl lg:text-5xl font-bold mb-3">
//             Apply Now for {job.title}
//           </h1>
//           <p className="text-base lg:text-lg max-w-2xl mx-auto opacity-90">
//             Submit your application and be part of our growing team at GetMax.
//           </p>
//         </div>

//         {/* Form Section */}
//         <div className="container mx-auto px-4 py-12 max-w-3xl">
//           <div className="bg-white shadow-lg border border-gray-200 p-8 md:p-10">
//             {isSubmitted ? (
//               <div className="flex flex-col text-center items-center justify-center py-12">
//                 ✅ Thank you! Your application has been submitted.
//               </div>
//             ) : (
//               <>
//                 <h2 className="text-2xl font-semibold mb-6 text-center text-gray-800">
//                   Application Form
//                 </h2>

//                 {error && (
//                   <div className="bg-red-100 text-red-600 px-4 py-3 border border-red-200 mb-6 text-sm text-center">
//                     {error}
//                   </div>
//                 )}

//                 <form onSubmit={handleSubmit} className="space-y-6">
//                   {/* Full Name & Email */}
//                   <div className="grid md:grid-cols-2 gap-6">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Full Name
//                       </label>
//                       <input
//                         type="text"
//                         name="fullName"
//                         required
//                         className="w-full px-3 py-2 border border-gray-300 focus:ring-2 focus:ring-teal-500"
//                         value={formData.fullName}
//                         onChange={handleChange}
//                       />
//                     </div>
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Email
//                       </label>
//                       <input
//                         type="email"
//                         name="email"
//                         required
//                         className="w-full px-3 py-2 border border-gray-300 focus:ring-2 focus:ring-teal-500"
//                         value={formData.email}
//                         onChange={handleChange}
//                       />
//                     </div>
//                   </div>

//                   {/* Phone */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Phone Number
//                     </label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 focus:ring-2 focus:ring-teal-500"
//                       value={formData.phone}
//                       onChange={handleChange}
//                     />
//                   </div>

//                   {/* Position */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Position
//                     </label>
//                     <input
//                       type="text"
//                       name="position"
//                       value={formData.position}
//                       readOnly
//                       className="w-full px-3 py-2 border border-gray-300 bg-gray-100 text-gray-700 cursor-not-allowed"
//                     />
//                   </div>

//                   {/* Experience & Education */}
//                   <div className="grid md:grid-cols-2 gap-6">
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Years of Experience
//                       </label>
//                       <select
//                         name="experience"
//                         required
//                         className="w-full px-3 py-2 border border-gray-300 focus:ring-2 focus:ring-teal-500"
//                         value={formData.experience}
//                         onChange={handleChange}
//                       >
//                         <option value="">Select</option>
//                         <option value="0-1">0-1</option>
//                         <option value="2-3">2-3</option>
//                         <option value="4-5">4-5</option>
//                         <option value="5+">5+</option>
//                       </select>
//                     </div>
//                     <div>
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Education
//                       </label>
//                       <select
//                         name="education"
//                         required
//                         className="w-full px-3 py-2 border border-gray-300 focus:ring-2 focus:ring-teal-500"
//                         value={formData.education}
//                         onChange={handleChange}
//                       >
//                         <option value="">Select</option>
//                         <option value="Bachelor's">Bachelor's</option>
//                         <option value="Master's">Master's</option>
//                         <option value="Doctorate">Doctorate</option>
//                       </select>
//                     </div>
//                   </div>

//                   {/* English Proficiency */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       English Proficiency
//                     </label>
//                     <select
//                       name="english"
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 focus:ring-2 focus:ring-teal-500"
//                       value={formData.english}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select</option>
//                       <option value="Basic">Basic</option>
//                       <option value="Intermediate">Intermediate</option>
//                       <option value="Fluent">Fluent</option>
//                     </select>
//                   </div>

//                   {/* Salary */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Last In-hand Monthly Salary
//                     </label>
//                     <input
//                       type="text"
//                       name="salary"
//                       className="w-full px-3 py-2 border border-gray-300 focus:ring-2 focus:ring-teal-500"
//                       value={formData.salary}
//                       onChange={handleChange}
//                     />
//                   </div>

//                   {/* Ready to Relocate */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Ready to Relocate?
//                     </label>
//                     <select
//                       name="relocate"
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 focus:ring-2 focus:ring-teal-500"
//                       value={formData.relocate}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select</option>
//                       <option value="Yes">Yes</option>
//                       <option value="No">No</option>
//                     </select>
//                   </div>

//                   {/* Resume */}
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Upload Resume (PDF/DOC)
//                     </label>
//                     <input
//                       type="file"
//                       name="resume"
//                       accept=".pdf,.doc,.docx"
//                       required
//                       className="w-full px-3 py-2 border border-gray-300 bg-gray-50 focus:ring-2 focus:ring-teal-500"
//                       onChange={handleFileChange}
//                     />
//                   </div>

//                   {/* Submit Button */}
//                   <button
//                     type="submit"
//                     disabled={loading}
//                     className={`w-full py-3 text-lg font-semibold text-white transition duration-300 ${
//                       loading
//                         ? "bg-gray-400 cursor-not-allowed"
//                         : "bg-gradient-to-l from-[#9629E7] to-[#0860C7]"
//                     }`}
//                   >
//                     {loading ? "Submitting..." : "Submit Application"}
//                   </button>
//                 </form>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ApplyPage;

import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { findJobById, loadJobs } from "./loadJobs";

const ApplyPage = () => {
  const { id } = useParams();
  const [job, setJob] = useState(null);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    position: "",
    experience: "",
    education: "",
    english: "",
    salary: "",
    relocate: "",
    resume: null,
  });

  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  const [userCountry, setUserCountry] = useState("");
  const [userRegion, setUserRegion] = useState("");
  const [jobLoading, setJobLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    loadJobs()
      .then((jobs) => {
        if (!isMounted) return;
        const matchedJob = findJobById(jobs, id);
        setJob(matchedJob || null);
        if (matchedJob?.title) {
          setFormData((prev) => ({ ...prev, position: matchedJob.title }));
        }
      })
      .catch((err) => {
        console.error("Error loading job:", err);
      })
      .finally(() => {
        if (isMounted) setJobLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [id]);

  // Fetch user geolocation
  useEffect(() => {
    const fetchGeo = async () => {
      try {
        const res = await fetch("https://get.geojs.io/v1/ip/geo.json");
        const data = await res.json();
        setUserCountry(data.country || "Unknown Country");
        setUserRegion(data.region || "Unknown Region");
      } catch (err) {
        console.error("Error fetching geolocation:", err);
      }
    };
    fetchGeo();
  }, []);

  if (jobLoading) return <div className="text-center py-10">Loading...</div>;
  if (!job) return <div className="text-center py-10">Job not found</div>;

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleFileChange = (e) =>
    setFormData({ ...formData, resume: e.target.files[0] });

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!formData.resume) {
      alert("Please upload your resume.");
      return;
    }

    setLoading(true);

    try {
      const resumeBase64 = await fileToBase64(formData.resume);
      const resumeFilename = formData.resume.name;

      const response = await fetch(
        `${import.meta.env.VITE_API_BASE}/addApplication?code=${
          import.meta.env.VITE_AZURE_FUNC_KEY
        }`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...formData,
            resumeBase64,
            resumeFilename,
            site: "Navishaa",
            siteLocation: userCountry || "Unknown",
            siteRegion: userRegion || "Unknown",
          }),
        }
      );

      let data = {};
      const text = await response.text();
      try {
        data = JSON.parse(text);
      } catch {
        console.warn("Backend returned non-JSON:", text);
        throw new Error(text || "Server returned an error");
      }

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Failed to submit application.");
      }

      setIsSubmitted(true);
    } catch (err) {
      console.error(err);
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {job?.title
            ? `${job.title} | Careers at Navishaa`
            : "Careers at Navishaa"}
        </title>
        <meta
          name="description"
          content={
            job?.description
              ? job.description.substring(0, 150) + "..."
              : "Explore exciting career opportunities at Navishaa."
          }
        />
      </Helmet>

      <div className="apply-page font-Questrial bg-gray-50 min-h-screen">
        {/* Hero Section */}
        <div
          className="hero relative py-16 lg:py-24 text-center text-white"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url("https://res.cloudinary.com/dbitupkaa/image/upload/f_auto,q_auto/v1737458572/HomePage_d3y2gy.png")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <h1 className="text-3xl lg:text-5xl font-bold mb-3">
            Apply Now for {job.title}
          </h1>
          <p className="text-base lg:text-lg max-w-2xl mx-auto opacity-90">
            Submit your application and be part of our growing team at Navishaa.
          </p>
        </div>

        {/* Form Section */}
        <div className="container mx-auto px-4 py-12 max-w-3xl">
          <div className="bg-white shadow-lg border border-gray-200 p-8 md:p-10">
            {isSubmitted ? (
              <div className="flex flex-col text-center items-center justify-center py-12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-green-500 w-16 h-16 mb-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <h2 className="text-2xl font-bold mb-2">Thank You!</h2>
                <p className="text-gray-600 max-w-md">
                  Your application has been submitted successfully. Our team
                  will get back to you shortly.
                </p>
              </div>
            ) : (
              <>
                <h2 className="text-2xl font-semibold mb-6 text-center text-gray-800">
                  Application Form
                </h2>

                {error && (
                  <div className="bg-red-100 text-red-600 px-4 py-3 border border-red-200 mb-6 text-sm text-center">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                  {/* Full Name & Email */}
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Full Name
                      </label>
                      <input
                        type="text"
                        name="fullName"
                        required
                        className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                        value={formData.fullName}
                        onChange={handleChange}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        required
                        className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Phone */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      required
                      className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Position */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Position
                    </label>
                    <input
                      type="text"
                      name="position"
                      value={formData.position}
                      readOnly
                      className="w-full px-3 py-2 border border-gray-300 bg-gray-100 text-gray-700 cursor-not-allowed"
                    />
                  </div>

                  {/* Experience & Education */}
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Years of Experience
                      </label>
                      <select
                        name="experience"
                        required
                        className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                        value={formData.experience}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="0-1">0-1</option>
                        <option value="2-3">2-3</option>
                        <option value="4-5">4-5</option>
                        <option value="5+">5+</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Education
                      </label>
                      <select
                        name="education"
                        required
                        className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                        value={formData.education}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="Bachelor's">Bachelor's</option>
                        <option value="Master's">Master's</option>
                        <option value="Doctorate">Doctorate</option>
                      </select>
                    </div>
                  </div>

                  {/* English */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      English Proficiency
                    </label>
                    <select
                      name="english"
                      required
                      className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                      value={formData.english}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Basic">Basic</option>
                      <option value="Intermediate">Intermediate</option>
                      <option value="Fluent">Fluent</option>
                    </select>
                  </div>

                  {/* Salary */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Last In-hand Monthly Salary
                    </label>
                    <input
                      type="text"
                      name="salary"
                      className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                      value={formData.salary}
                      onChange={handleChange}
                    />
                  </div>

                  {/* Relocate */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Ready to Relocate?
                    </label>
                    <select
                      name="relocate"
                      required
                      className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500"
                      value={formData.relocate}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  {/* Resume */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Upload Resume (PDF/DOC)
                    </label>
                    <input
                      type="file"
                      name="resume"
                      accept=".pdf,.doc,.docx"
                      required
                      className="w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 bg-gray-50"
                      onChange={handleFileChange}
                    />
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={loading}
                    className={`w-full py-3 text-lg font-semibold text-white transition duration-300 ${
                      loading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-l from-[#9629E7] to-[#0860C7] hover:opacity-90"
                    }`}
                  >
                    {loading ? "Submitting..." : "Submit Application"}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplyPage;
